import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "chats" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = {
  key: 1,
  class: "chat-list"
}
const _hoisted_4 = { class: "row justify-center q-my-md" }

import { storeToRefs } from 'pinia';
import { QInfiniteScroll } from 'quasar';
import useMessenger from 'SharedDir/common/composables/useMessenger';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { Chats } from 'SharedDir/declarations/chats';
import ChatMessage from 'SharedDir/service/chats/classes/chat-message';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import useCentrifuge from 'SharedDir/common/composables/useCentrifuge';
import Chat from 'SharedDir/modules/Chats/Chat.vue';
import Thread from 'SharedDir/modules/Chats/Thread.vue';
import { useUserStore } from 'SharedDir/stores/user.store';
import { useChatStore } from 'SharedDir/stores/chat.store';
import { useLoading } from 'SharedDir/common/composables/useLoading';
import { usePermissions } from 'SharedDir/common/composables/usePermissions';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'TheChat' },
  __name: 'TheChat',
  setup(__props, { expose: __expose }) {


const userStore = useUserStore();
const chatStore = useChatStore();
const { action: loading } = useLoading();
const { canAny, permissionSet } = usePermissions();
const { showChat } = storeToRefs(chatStore);
const { centrifuge, centrifugeReady } = useCentrifuge();

const refInfiniteScroll = ref<QInfiniteScroll>(null as any);
const chatFilter = ref<string | null>(null);
const silent = { useLoader: false };

const {
  init,
  refThread,
  chats,
  moreMessages,
  moreChats,
  send,
  remove,
  currentChatMessages,
  newCurrentChatMessageReceiveHook,
  setCurrentChat,
  receiveChat,
  shutdown,
  unreadMessagesCount,
  setCurrent,
  currentChat,
  toggleMute,
  togglePin,
} = useMessenger();

const filteredChats = computed(() => {
  if (chatFilter.value) {
    console.log(chatFilter.value);
    return chats.value.filter((chat) =>
      (chat.name || '').toLowerCase().includes((chatFilter.value as string).toLowerCase())
    );
  }
  return chats.value;
});

const getCloseIcon = computed(() => {
  if (currentChat.value) {
    return 'app:arrow-light-left';
  }

  return 'app:close';
});

function loadMoreMessages(index: number, done: (stop?: boolean) => void) {
  // Напрямую вызывать эти методы из верстки невозможно потому что Vue прокидывает в вызов свой контекст
  return makeRequest(() => moreMessages(index, done), silent);
}

function loadMoreChats(index: number, done: (stop?: boolean) => void) {
  // Напрямую вызывать эти методы из верстки невозможно потому что Vue прокидывает в вызов свой контекст
  return makeRequest(() => moreChats(index, done), silent);
}

function sendMessage(message: Chats.Message, resolve: () => void, reject: (e: any) => void) {
  // Напрямую вызывать эти методы из верстки невозможно потому что Vue прокидывает в вызов свой контекст
  makeRequest(() => send(message, resolve, reject), silent);
}

function deleteMessage(message: ChatMessage) {
  // Напрямую вызывать эти методы из верстки невозможно потому что Vue прокидывает в вызов свой контекст
  makeRequest(() => remove(message), silent);
}

// function updateMessage(id: Chats.Message['id'], message: ChatMessage) {
//   // Напрямую вызывать эти методы из верстки невозможно потому что Vue прокидывает в вызов свой контекст
//   makeRequest(() => updateMessage(id, message), silent);
// }

onMounted(async () => {
  if (canAny([permissionSet.chat.list])) {
    await init();
    newCurrentChatMessageReceiveHook.value = () => {
      refThread.value.scrollToBottom();
    };
  }
});

async function openChat(chatId: number) {
  try {
    loading.show();
    const chat = await receiveChat(chatId);
    setCurrentChat(chat);
    showChat.value = true;
  } finally {
    loading.hide();
  }
}

function close() {
  if (currentChat.value) {
    currentChat.value = null;
  } else {
    showChat.value = false;
  }
}
onUnmounted(() => {
  console.debug('Destroying...');
  close();
  shutdown();
});

__expose({ openChat });

return (_ctx: any,_cache: any) => {
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_SModal = _resolveComponent("SModal")!

  return (_openBlock(), _createBlock(_component_SModal, {
    "model-value": _unref(showChat),
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(showChat) ? (showChat).value = $event : null)),
    "with-header": false,
    persistent: false,
    size: "small",
    position: "right",
    "transition-show": "slide-up",
    class: "chat-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex items-center", _unref(currentChat) ? 'justify-start' : 'justify-between'])
        }, [
          (!_unref(currentChat))
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Список чатов "))
            : _createCommentVNode("", true),
          _createVNode(_component_s_icon, {
            name: getCloseIcon.value,
            "onUpdate:name": _cache[0] || (_cache[0] = ($event: any) => ((getCloseIcon).value = $event)),
            color: "brand",
            onClick: close
          }, null, 8, ["name"])
        ], 2),
        (!_unref(currentChat))
          ? (_openBlock(), _createBlock(_component_s_input, {
              key: 0,
              modelValue: chatFilter.value,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((chatFilter).value = $event)),
                _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('request')))
              ],
              debounce: "600",
              dense: "",
              class: "search-input m-none-auto",
              placeholder: "Поиск чатов",
              clearable: ""
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "app:search" })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (!_unref(currentChat))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(QInfiniteScroll), {
                ref_key: "refInfiniteScroll",
                ref: refInfiniteScroll,
                onLoad: loadMoreChats
              }, {
                loading: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_q_spinner, {
                      color: "brand",
                      name: "dots",
                      size: "40px"
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredChats.value, (chat, index) => {
                      return (_openBlock(), _createBlock(Chat, {
                        key: index,
                        data: chat,
                        class: _normalizeClass({ active: _unref(currentChat) && chat.id === _unref(currentChat).id }),
                        onClick: ($event: any) => (_unref(setCurrent)(chat)),
                        onMute: ($event: any) => (_unref(toggleMute)(chat)),
                        onPin: ($event: any) => (_unref(togglePin)(chat))
                      }, null, 8, ["data", "class", "onClick", "onMute", "onPin"]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 512)
            ]))
          : _createCommentVNode("", true),
        (_unref(currentChat))
          ? (_openBlock(), _createBlock(Thread, {
              key: 2,
              ref_key: "refThread",
              ref: refThread,
              class: "thread",
              dense: "",
              "chat-name": _unref(currentChat).name,
              messages: _unref(currentChatMessages),
              onLoad: loadMoreMessages,
              onSend: sendMessage,
              onDelete: deleteMessage
            }, null, 8, ["chat-name", "messages"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})